export type CocheType = 'turismo' | 'otros'

export enum CocheTypeEnum {
  TURISMO = 'turismo',
  OTROS = 'otros',
}
